import { buildFileUrl } from '@sanity/asset-utils';
import type { SanityDocumentAssetSource } from '$lib/sanity/schemas';

export class FileUrlBuilder {
  private projectId: string;
  private dataset: string;

  constructor(projectId: string, dataset: string) {
    this.projectId = projectId;
    this.dataset = dataset;
  }

  url(fileAsset: SanityDocumentAssetSource): string {
    let fileUrl = '';
    let fileId = '';
    let fileExtension = '';

    if (typeof fileAsset === 'string') {
      const [_file, id, extension] = fileAsset.split('-');
      fileId = id;
      fileExtension = extension;
    } else if ('_ref' in fileAsset) {
      const [_file, id, extension] = fileAsset._ref.split('-');
      fileId = id;
      fileExtension = extension;
    } else if (fileAsset.extension) {
      fileId = fileAsset._id;
      fileExtension = fileAsset?.extension;
    }

    fileUrl = buildFileUrl(
      { assetId: fileId, extension: fileExtension },
      { projectId: this.projectId, dataset: this.dataset }
    );

    return fileUrl;
  }
}
